<div class="calendar-event-container hand" [ngClass]="containerClass()">
    <div class="calendar-event" [ngClass]="{'calendar-event-cancelled': isCancelled}" [popover]="popTemplate"
        placement="{{popoverSide}}" container="body" containerClass="calendar-event-popover" [outsideClick]="true"
        #pop="bs-popover" triggers="" (click)="showPopover($event, pop)">


        <div class="calendar-event-body px-2" [ngClass]="{'pt-1': isMoreThan15MinutesEvent()}">
            <div class="row no no-gutters font-weight-bold text-truncate d-flex">
                <div>{{model.name}}</div>
                <div *ngIf="!!model.fee" class="ml-1"><span class="ic-dollar-small"></span></div>
            </div>
            <div class="row no no-gutters font-weight-bold text-uppercase text-truncate"
                *ngIf="isMoreThan15MinutesEvent()">{{model.category.name}}</div>
            <div class="row no no-gutters text-truncate" *ngIf="isMoreThan30MinutesEvent()">
                <app-instructor-label [nominalInstructor]="model.instructor"
                    [substituteInstructor]="model.substituteInstructor"></app-instructor-label>
            </div>
            <div class="row no no-gutters text-truncate" *ngIf="isMoreThan45MinutesEvent()">
                {{model.originalTimeFromInMinutes | timeDisplay : true}} -
                {{model.originalTimeToInMinutes | timeDisplay : true}}
            </div>
        </div>

    </div>

    <ng-template #popTemplate>
        <div class="row justify-content-end no-gutters calendar-event-popover-header py-2 px-2">
            <div class="col d-flex align-items-center">

                <span class="clickable clickable-action pr-2" (click)="onSubstitute()"
                    [showIfPrivileges]="'GroupClasses.canManageClasses'" [clubIds]="clubId"
                    *ngIf="canSubstitute">{{'CalendarEvent.Substitute' | translate}}</span>

                <span class="clickable clickable-action pr-2" (click)="onCancelSubstitution()"
                    [showIfPrivileges]="'GroupClasses.canManageClasses'" [clubIds]="clubId"
                    *ngIf="canCancelSubstitution">{{'CalendarEvent.CancelSubstitution' | translate}}</span>

                <span class="clickable clickable-action" (click)="onCancel()"
                    [showIfPrivileges]="'GroupClasses.canManageClasses'" [clubIds]="clubId"
                    *ngIf="!isCancelled">{{'CalendarEvent.CancelClass' | translate}}</span>

                <ng-container *ngIf="isCancelled">
                    <span *bcIfPrivileges="'GroupClasses.canManageClasses'; clubIds clubId"
                        class="clickable clickable-action" (click)="onRestore()" translate>
                        CalendarEvent.RestoreClassMenuItem</span>
                </ng-container>

                <span class="badge badge-danger py-1 ml-2"
                    *ngIf="isCancelled">{{'CalendarEvent.CancelledClass' | translate}}</span>

                <span class="ic-more-white clickable px-3" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false" *ngIf="canCopy | async"></span>

                <div class="dropdown-menu">
                    <a class="dropdown-item clickable" *ngIf="isCopyToTomorrowVisible"
                        (click)="onCopyToTomorrow()">{{'CopyGroupClassMethod.CopyToTomorrow'
                        |
                        translate}}</a>
                    <a class="dropdown-item clickable" *ngIf="isCopyToNextWeekVisible"
                        (click)="onCopyToNextWeek()">{{'CopyGroupClassMethod.CopyToNextWeekday'
                        | translate: {weekday: model.date | bcDate: 'dddd'} }}</a>
                    <a class="dropdown-item clickable" *ngIf="isCopyToEveryDayThisWeekVisible"
                        (click)="onCopyToEveryDayThisWeek()">{{'CopyGroupClassMethod.CopyToEveryDayThisWeek'
                        | translate}}</a>
                    <a class="dropdown-item clickable" *ngIf="isCopyToEveryWeekdayThisMonthVisible"
                        (click)="onCopyToEveryWeekdayThisMonth()">{{'CopyGroupClassMethod.CopyToEveryWeekdayThisMonth'
                        | translate: {weekday: model.date | bcDate: 'dddd'} }}</a>
                    <a class="dropdown-item clickable" *ngIf="isCopyToEveryDayThisMonthVisible"
                        (click)="onCopyToEveryDayThisMonth()">{{'CopyGroupClassMethod.CopyToEveryDayThisMonth'
                        | translate}}</a>

                    <a class="dropdown-item clickable" (click)="onEdit()" *ngIf="!isCancelled">{{'CalendarEvent.Edit'
                        | translate}}</a>

                    <a class="dropdown-item clickable" (click)="onRemove()"
                        [showIfPrivileges]="'GroupClasses.canManageClasses'" [clubIds]="clubId">{{'CalendarEvent.Remove'
                        | translate}}</a>

                    <a class="dropdown-item clickable" (click)="onSubRequest()"
                        *ngIf="canRequestSub">{{'CalendarEvent.CreateSubRequest'
                            | translate}}</a>
                </div>
            </div>
            <div class="col-auto">
                <div (click)="closePopover()"><span class="ic-close-white clickable mr-2"></span></div>
            </div>
        </div>
        <div class="calendar-event-popover-body py-3">
            <div class="row no-gutters">
                <div class="col-2 text-center">
                    <app-group-classes-category-icon [category]="model.category.code" [status]="model.status.code">
                    </app-group-classes-category-icon>
                </div>
                <div class="col font-weight-bold clickable" (click)="onView()"
                    [ngClass]="{'bay-club-blue': !isCancelled, 'red': isCancelled}">
                    <div>{{model.name}}</div>
                    <div class="text-uppercase">{{model.category.name}}</div>
                </div>
            </div>

            <div class="row no-gutters mt-2">
                <div class="col-2 text-center"><span class="ic-calendar-primary"></span></div>
                <div class="col">{{model.date | bcDate: 'dddd'}}, {{model.date | bcDate: 'MMM Do YY'}}</div>
            </div>

            <div class="row no-gutters mt-2">
                <div class="col-2 text-center"><span class="ic-clock-primary"></span></div>
                <div class="col">
                    {{model.originalTimeFromInMinutes | timeDisplay : true}} -
                    {{model.originalTimeToInMinutes | timeDisplay : true}}
                </div>
            </div>

            <div class="row no-gutters mt-2" *ngIf="model.location">
                <div class="col-2 d-flex justify-content-center">
                    <div class="location location-order-{{model.location.order}}"></div>
                </div>

                <div class="col">{{model.location.name}}</div>
            </div>

            <div class="row no-gutters mt-2">
                <div class="col-2 text-center"><span class="ic-instructor-primary"></span></div>
                <app-instructor-label class="col" [nominalInstructor]="model.instructor"
                    [substituteInstructor]="model.substituteInstructor">
                </app-instructor-label>
            </div>

            <div class="row no-gutters mt-2" *ngIf="model.fee">
                <div class="col-2 text-center"><span class="ic-dollar-big"></span></div>
                <div class="col">{{ model.fee | currency }}</div>
            </div>
        </div>

    </ng-template>


</div>